module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("A Book of Songs and Poetry")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#the-golden-moon"
    }
  }, [_vm._v("The Golden Moon")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#oh-lilliana"
    }
  }, [_vm._v("Oh Lilliana")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#autumn"
    }
  }, [_vm._v("Autumn")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#little-one",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Little One")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#lilly",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lilly")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#mother",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mother")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Home")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#run-the-field",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Run the Field")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#freedom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Freedom")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#man",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Man")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#mine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mine")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#month-of-may-oh-lilly-oh-lilly-o-lilly-o-lilly-o",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Month of May – (Oh Lilly Oh Lilly O-Lilly-O Lilly-O)")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#hide-and-seek",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hide and Seek")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#brother",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brother")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#immortal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Immortal")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#true-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("True Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#truth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Truth")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#the-contented-man",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Contented Man")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#oh-precious-tree",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oh Precious Tree")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#a-vision",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Vision")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#man-to-man",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Man to Man")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#october",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("October")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#obsession",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Obsession")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#mr-pritcher",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mr Pritcher")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#dawn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dawn")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#boredom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boredom")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#time-lost",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Time Lost")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#a-song-for-cruisers-original",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Song for Cruisers (Original)")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#a-song-for-cruisers-living-the-dream",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Song for Cruisers Living the Dream…")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#afraid",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afraid?")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#bitter-dreams-and-emptiness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bitter Dreams and Emptiness")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#chance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chance")])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#hey-little-man",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hey, Little Man")])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#my-little-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Little Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#dreams",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dreams")])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life")])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#do-you-know",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Do You Know?")])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#autumn-finale",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Autumn – Finale")])]), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#something",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Something")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0